const cmpReadMore = {
  component: null,

  init: function (element) {
    const _ = this
    _.component = element

    const less = element.getAttribute('data-less')
    const more = element.getAttribute('data-more')
    const controls = element.getAttribute('aria-controls')
    const target = document.getElementById(controls)
    if (_.component.classList.contains('open-disclaimer')) {
      setTimeout(() => {
        _.component.click()
      }, 400)
    }
    if (target) {
      element.addEventListener('click', function (event) {
        event.stopPropagation()

        if (element.getAttribute('aria-expanded') === 'false') {
          element.setAttribute('aria-expanded', 'true')
          if (less) {
            element.textContent = less
          }
          _.expand(target)
        } else {
          element.setAttribute('aria-expanded', 'false')
          if (more) {
            element.textContent = more
          }
          _.collapse(target)
        }
      })
    }
  },

  collapse: function (element) {
    const h = element.scrollHeight
    const t = element.style.transition
    element.style.transition = ''
    window.requestAnimationFrame(function () {
      element.style.height = h + 'px'
      element.style.transition = t

      window.requestAnimationFrame(function () {
        element.style.height = 0 + 'px'
      })
    })
  },

  expand: function (element) {
    const h = element.scrollHeight
    element.style.height = h + 'px'
  }
}

export default cmpReadMore
